import React, { useCallback } from 'react';

import Traductor from 'components/Traductor';
import { ReactComponent as TrolleyIcon } from 'images/icons/trolley.svg';

const TrolleyButton = ({
    loading,
    vehicle,
    onTrolleyButtonClick,
    cars,
    countDownStatus,
}) => {
    const t = new Traductor();

    //Update trolley button tip, bronson-tippy workaround
    const setTrolleyTip = useCallback(
        text => {
            const button = document.getElementById(
                `trolley-button-${vehicle.Id}`
            );
            if (button?._tippy) {
                button._tippy.setContent(text);
            }
        },
        [vehicle.Id]
    );

    if (
        loading ||
        vehicle.IsBlocked ||
        !vehicle?.HasOpenLotModality ||
        vehicle.AmountAWS ||
        vehicle.Status !== 2 ||
        countDownStatus !== 1 //Disable add to batch from card if loading, auction haven't started, vehicle has any bid, been bought or added to another batch or hasn't batch option
    ) {
        return (
            <button
                className="o-layout__item u-1/6 c-btn  c-btn--icon-only  c-btn--medium  c-btn--round u-float-right u-bg-brand c-btn--disabled c-btn-trolley-container"
                onClick={() => null}
                disabled
                aria-disabled="true"
            >
                <span
                    className="o-relative u-flex"
                    style={{ width: '1.71429em', height: '1.71429em' }}
                >
                    <TrolleyIcon
                        id="c-trolley-icon"
                        className="c-icon c-btn__icon c-icon--small"
                        alt="Shopping cart icon"
                    />
                    <i
                        id="c-trolley-icon-content"
                        className="c-icon  c-icon--[semantic-zoom-in] u-round u-text-brand"
                    />
                </span>
            </button>
        );
    }

    const carInsideBatch = cars.some(car => car.Id === vehicle.Id);

    if (carInsideBatch) {
        return (
            <button
                id={`trolley-button-${vehicle.Id}`}
                className="o-layout__item u-1/6 c-btn  c-btn--icon-only  c-btn--medium  c-btn--round u-float-right js-tooltip u-bg-success c-btn-trolley-container"
                data-tippy-content={t.getTraduction('RemoveFromBatch')}
                onClick={e => {
                    onTrolleyButtonClick(e, false);
                    setTrolleyTip(t.getTraduction('AddToBatch'));
                }}
            >
                <span
                    className="o-relative u-flex"
                    style={{ width: '1.71429em', height: '1.71429em' }}
                >
                    <TrolleyIcon
                        id="c-trolley-icon"
                        className="c-icon c-btn__icon c-icon-white c-icon--small"
                        alt="Shopping cart icon"
                    />
                    <i
                        id="c-trolley-icon-content"
                        className="c-icon  c-icon--[semantic-success] u-round u-text-success"
                    />
                </span>
            </button>
        );
    }
    return (
        <button
            id={`trolley-button-${vehicle.Id}`}
            className="o-layout__item u-1/6 c-btn  c-btn--icon-only  c-btn--medium  c-btn--round u-float-right u-bg-brand js-tooltip c-btn-trolley-container"
            data-tippy-content={t.getTraduction('AddToBatch')}
            onClick={e => {
                onTrolleyButtonClick(e, true);
                setTrolleyTip(t.getTraduction('RemoveFromBatch'));
            }}
        >
            <span
                className="o-relative u-flex"
                style={{ width: '1.71429em', height: '1.71429em' }}
            >
                <TrolleyIcon
                    id="c-trolley-icon"
                    className="c-icon c-btn__icon c-icon--small"
                    alt="Shopping cart icon"
                />
                <i
                    id="c-trolley-icon-content"
                    className="c-icon  c-icon--[semantic-zoom-in] u-round u-text-brand"
                />
            </span>
        </button>
    );
};

export default TrolleyButton;
